import { gql } from '@apollo/client';
import SUPPORT_FACILITY_FRAGMENT from '../fragments/supportFacilityFragment';

const ME_QUERY = gql`
  query me {
    me {
      id
      firstName
      lastName
      contact {
        phone1
        country
        address
        city
        zip
        state
      }
      username
      email
      roles
      freshChatRestoreId
      willViewTutorialLater
      canUseAiViewer
      isEmailVerified
      photo
      createdAt
      lastChangeEmail
      title
      sessionId
      organization {
        id
        slug
        logo {
          full
        }
      }
      includeContactToReport
      supportFacilities {
        ...SupportFacilityFragment
      }
    }
  }

  ${SUPPORT_FACILITY_FRAGMENT}
`;

export default ME_QUERY;
